import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSession from "vue-session";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import * as VueGoogleMaps from "vue2-google-maps";
// "vue".use(window.VueCharts);

import "./assets/style.scss";

Vue.use(VueAxios, axios);
Vue.use(VueSession);
Vue.use(VueMoment, {
  moment,
});
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAFKwcIfE3yd0hxR2ES8A9lTRMmPlV22ow",
    libraries: "places", // necessary for places input
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  data() {
    return {
      access_key: "",
      app_name: "ONLINE WATER LEVEL MONITORING SYSTEM",
      httpurl: "http://216.10.247.24:3000/",
      weburl: "http://216.10.247.24/",
      //httpurl: "http://localhost:3000/",
      //weburl: "http://localhost/",

      disconnection_time: 60,
      reload_duration: 30 * 1000,
      status_options: [
        { value: 0, text: "Disabled" },
        { value: 1, text: "Enabled" },
      ],
      state_options: [
        { id: 1, value: "in-mh", text: "Maharashtra" },
        { id: 2, value: "in-up", text: "Uttar Pradesh" },
        { id: 3, value: "in-hr", text: "Haryana" },
        { id: 4, value: "in-rj", text: "Rajasthan" },
        { id: 5, value: "in-uk", text: "Uttarakhand" },
        { id: 6, value: "in-dl", text: "Delhi" },
      ],
    };
  },
  methods: {
    is_logged_in() {
      console.log(this.$session.get("access_key"));

      if (this.$session.get("access_key") == "" || this.$session.get("access_key") == undefined) {
        this.$session.destroy();
        this.$router.push("/");
        return 1;
      } else {
        return 0;
      }
    },
    tofixed(value, param) {
      return value.toFixed(param);
    },
    getDashboardLink() {
      console.log("-----getDashboardLink----");
      var userinfo = this.$session.get("user_info");
      if (userinfo.permissions.dashboard_link != "" && userinfo.permissions.dashboard_link != undefined) {
        return userinfo.permissions.dashboard_link;
      } else {
        return "/dashboard";
      }
    },
    chkperm(option, perm) {
      console.log("-----chkperm----");
      var userinfo = this.$session.get("user_info");
      if (userinfo.role == 1 || userinfo.role == "1") {
        return 1;
      }
      var options = userinfo.options;
      if (options[option]) {
        if (options[option].indexOf(perm) > -1) {
          return 1;
        }
      }
      return 0;
    },
    forceLogout(msg) {
      var self = this;
      var userinfo = this.$session.get("user_info");
      if (userinfo.permissions.multi_login <= 0 || userinfo.permissions.multi_login == "0") {
        this.$bvModal
          .msgBoxOk(msg, {
            title: "Security Issue",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Logout",
            okOnly: true,
            footerClass: "p-2",
            backdrop: "static",
            hideHeaderClose: true,
            centered: true,
          })
          .then((value) => {
            if (value == true) {
              self.$session.destroy();

              self.$router.push("/");
            }
          })
          .catch((err) => {
            // An error occurred
            console.log(err);
          });
      }
    },
    showMessage(title, msg, okTitle, callback = "") {
      this.$bvModal
        .msgBoxOk(msg, {
          title: title,
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: okTitle,
          okOnly: true,
          footerClass: "p-2",
          backdrop: "static",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            if (callback != "") {
              callback();
            }
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
  },
}).$mount("#app");
